export const CANONICAL_DOMAIN = "https://integradyn.ai";

export function getCanonicalUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${CANONICAL_DOMAIN}${cleanPath}`;
}

export function updateCanonicalUrl(path: string): void {
  const canonicalUrl = getCanonicalUrl(path);
  
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', canonicalUrl);

  let ogUrl = document.querySelector('meta[property="og:url"]');
  if (!ogUrl) {
    ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    document.head.appendChild(ogUrl);
  }
  ogUrl.setAttribute('content', canonicalUrl);
}

interface SEOConfig {
  path: string;
  title: string;
  description: string;
  ogImage?: string;
  ogType?: string;
}

export function updatePageSEO(config: SEOConfig): void {
  const { path, title, description, ogImage = '/og-image.png', ogType = 'website' } = config;
  const canonicalUrl = getCanonicalUrl(path);
  
  document.title = title;
  
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', canonicalUrl);
  
  const setMeta = (selector: string, attribute: string, value: string) => {
    let el = document.querySelector(selector);
    if (!el) {
      el = document.createElement('meta');
      const attrName = selector.includes('property=') ? 'property' : 'name';
      const attrValue = selector.match(/["']([^"']+)["']/)?.[1] || '';
      el.setAttribute(attrName, attrValue);
      document.head.appendChild(el);
    }
    el.setAttribute(attribute, value);
  };
  
  setMeta('meta[name="description"]', 'content', description);
  
  const getFullImageUrl = (img: string): string => {
    if (img.startsWith('http://') || img.startsWith('https://')) {
      return img;
    }
    return `${CANONICAL_DOMAIN}${img.startsWith('/') ? img : '/' + img}`;
  };
  
  const fullImageUrl = getFullImageUrl(ogImage);
  
  setMeta('meta[property="og:title"]', 'content', title);
  setMeta('meta[property="og:description"]', 'content', description);
  setMeta('meta[property="og:url"]', 'content', canonicalUrl);
  setMeta('meta[property="og:type"]', 'content', ogType);
  setMeta('meta[property="og:image"]', 'content', fullImageUrl);
  setMeta('meta[property="og:site_name"]', 'content', 'Integradyn');
  
  setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
  setMeta('meta[name="twitter:title"]', 'content', title);
  setMeta('meta[name="twitter:description"]', 'content', description);
  setMeta('meta[name="twitter:image"]', 'content', fullImageUrl);
}
